import { render } from "./ProjectPublicationHistoryList.vue?vue&type=template&id=fe8a315e&scoped=true"
import script from "./ProjectPublicationHistoryList.vue?vue&type=script&lang=js"
export * from "./ProjectPublicationHistoryList.vue?vue&type=script&lang=js"

import "./ProjectPublicationHistoryList.vue?vue&type=style&index=0&id=fe8a315e&lang=scss&scoped=true"
import "./ProjectPublicationHistoryList.vue?vue&type=style&index=1&id=fe8a315e&lang=scss"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe8a315e"]])

export default __exports__